import React from 'react';
import { useRecoilState } from 'recoil';
import { mockupState } from '../../../../Recoil/RecoilState';
import UploadImage from './UploadImage';
import isMobile from 'ismobilejs';
import styled, { css } from 'styled-components';
import Button from '../../buttons/Button';
import { ButtonColor } from '../../buttons/Button';
import { ReactComponent as Cursor } from '../../../../assets/icons/cursor.svg';
import { ReactComponent as HandUp } from '../../../../assets/icons/hand_up.svg';
interface Props {
  showTooltip?: () => void;
}

type StyleProps = {
  isMobile: boolean;
};

const UploadImageListWrapper = styled.div<StyleProps>`
  ${(props) =>
    props.isMobile
      ? css`
          white-space: nowrap;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          padding: 4rem;
        `
      : null}

  display: grid;
  gap: 1rem;
  align-content: space-between;
  height: 100%;

  .uploadImageList__buttons {
    display: grid;
    gap: 1rem;
    ${(props) =>
      props.isMobile
        ? css`
            justify-content: center;
          `
        : css``}
  }
`;

const UploadImageList: React.FC<Props> = (props) => {
  const [mockupGeneralState] = useRecoilState(mockupState);

  const renderUploadInputs = () => {
    return Object.keys(mockupGeneralState.userUploads).map((id, index) => {
      const upload = mockupGeneralState.userUploads[id];
      return (
        <UploadImage
          showTooltip={props.showTooltip}
          isSelected={
            mockupGeneralState.selectedImage && mockupGeneralState.selectedImage.id === id
          }
          key={id}
          userUpload={upload}
          userUploads={mockupGeneralState.userUploads}
          imageStock={mockupGeneralState.uploadedImagesStock}
          index={index}
        />
      );
    });
  };

  return (
    <UploadImageListWrapper isMobile={isMobile(window.navigator).any}>
      <div className="uploadImageList__buttons">
        {renderUploadInputs()}
        <Button
          color={ButtonColor.gray10}
          label="Create With Designer"
          onClick={() => {
            window.open('https://designer.vexels.com/', '_blank');
          }}
          iconSVG={<Cursor />}
          borderRadius={'var(--rounded-lg)'}
          textColor="var(--color-gray-800)"
          gap={'6px'}
        />
      </div>

      <div>
        <Button
          color={ButtonColor.white}
          label="Send Feedback"
          onClick={() => {
            window.open('https://feedback.vexels.com/new-post', '_blank');
          }}
          iconSVG={<HandUp />}
          borderRadius={'var(--rounded-full)'}
          textColor="var(--color-gray-700)"
          gap={'6px'}
          textColorHover="var(--color-gray-800)"
          boxShadow="var(--shadow-lg)"
        />
      </div>
    </UploadImageListWrapper>
  );
};

export default UploadImageList;
